module.exports = __webpack_public_path__ + "static/img/d_icon5.80250045.png";